import React from "react";
import ErrorMessage from "../../Tooltips/ErrorMessage";
import { TByPassReason } from "../../../../store/superadmin/types";
import { getFormatedDate } from "../../../../utils/dataParser";

interface CharacterLimitTextareaProps {
  value: string;
  onChange: (value: string) => void;
  maxLength: number;
  placeholder?: string;
  error?: string;
  type?: string;
  disabled?: boolean;
  doneBy?: TByPassReason;
}

const CharacterLimitTextarea: React.FC<CharacterLimitTextareaProps> = ({
  value = "",
  onChange,
  maxLength,
  placeholder = "Enter comment...",
  error = "",
  type,
  disabled=false,
  doneBy
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>): void => {
    const newValue = e.target.value;
    if (newValue.length <= maxLength) {
      onChange(newValue); // propagate to parent
    }
  };

  return (
    <>
      <div className="d-flex flex-column gap-5">
        <div className="form-group">
          <textarea
            className={`form-control py-10px ${disabled ? `border-grey-light` : ``}`}
            value={value}
            onChange={handleChange}
            maxLength={maxLength}
            placeholder={placeholder}
            disabled={disabled}
          />
        </div>
        <ErrorMessage message={error} />
        { (type !== "withdraw" && type !== "decline") ? 
        <div className="d-flex justify-content-end">
          <div className="fs-13 text-grey-medium">
            { doneBy && doneBy !== null ? `Actioned by ${doneBy?.created_by} on ${getFormatedDate(doneBy?.created_at ?? "")}` : `${value.length}/${maxLength}`}
          </div>
        </div> : "" }
      </div>
    </>
  );
};

export default CharacterLimitTextarea;
